import { render } from "./DialogInvalidPageAccess.vue?vue&type=template&id=2dceb050"
import script from "./DialogInvalidPageAccess.vue?vue&type=script&lang=js"
export * from "./DialogInvalidPageAccess.vue?vue&type=script&lang=js"
script.render = render

export default script